import { BUSCA_INSTITUIDOR_PENSAO_ERRO, BUSCA_INSTITUIDOR_PENSAO_SUCESSO, ENTIDADES_ASSOCIATIVAS_BUSCAR_STATUS_PROTOCOLO_HERDEIRO_ERRO, ENTIDADES_ASSOCIATIVAS_BUSCAR_STATUS_PROTOCOLO_HERDEIRO_SUCESSO, ENTIDADES_ASSOCIATIVAS_CONSULTAR_ERRO_CONSULTAR_DESCONTOS, ENTIDADES_ASSOCIATIVAS_CONSULTAR_FINALIZA_REQUISICAO, ENTIDADES_ASSOCIATIVAS_CONSULTAR_INICIAR_REQUISICAO, ENTIDADES_ASSOCIATIVAS_CONSULTAR_REQUERIMETO_ERRO, ENTIDADES_ASSOCIATIVAS_CONSULTAR_REQUERIMETO_SUCESSO, ENTIDADES_ASSOCIATIVAS_CONSULTAR_SET_DADOS_PROTOCOLO_CADHERD, ENTIDADES_ASSOCIATIVAS_CONSULTAR_SET_RESPOSTA_REQUISICAO, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_FINALIZAR_REQUISICAO, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_INICIAR_REQUISICAO, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_DADOS_CONTATO, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_FEEDBACKS, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_LISTA_DESCONTOS_AUTORIZADOS, ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_LISTA_DESCONTOS_NAO_AUTORIZADOS, ENTIDADES_ASSOCIATIVAS_SET_TELA_ACAO, INICIAR_BUSCA_INSTITUIDOR_PENSAO } from "./constants";

const INITIAL_STATE = {
    //Consultar
    loadingRequest: false,
    loadingInstituidor: false,
    respostaConsultaDescontos: [],
    error: false,
    //Requerimento
    listaEntidadesNaoAutorizadas: [],
    listaEntidadesAutorizadas: [],
    dadosContato: {},
    requerimentoErro: false,
    requerimentoSucesso: false,
    feedbackRequerimentos: [],
    loadingRequerimentos: false,
    dadosInstituidorPensao: {},
    dadosProtocoloCadherd: {},
}

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case ENTIDADES_ASSOCIATIVAS_BUSCAR_STATUS_PROTOCOLO_HERDEIRO_SUCESSO: 
            return { ...state, dadosProtocoloCadherd: action.payload, loadingRequest: false }
        case ENTIDADES_ASSOCIATIVAS_BUSCAR_STATUS_PROTOCOLO_HERDEIRO_ERRO:
            return { ...state, error: action.payload, loadingRequest: false, dadosProtocoloCadherd: {} }
        case INICIAR_BUSCA_INSTITUIDOR_PENSAO:
            return { ...state, error: false, loadingInstituidor: true }
        case BUSCA_INSTITUIDOR_PENSAO_ERRO:
            return { ...state, error: action.payload, loadingInstituidor: false }
        case BUSCA_INSTITUIDOR_PENSAO_SUCESSO:
            return { ...state, dadosInstituidorPensao: action.payload, loadingInstituidor: false }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_SET_RESPOSTA_REQUISICAO:
            return { ...state, error: false, loadingRequest: false, respostaConsultaDescontos: action.payload }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_SET_DADOS_PROTOCOLO_CADHERD:
            return { ...state, dadosProtocoloCadherd: action.payload }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_INICIAR_REQUISICAO:
            return { ...state, error: false, loadingRequest: true }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_FINALIZA_REQUISICAO:
            return { ...state, error: false, loadingRequest: false }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_ERRO_CONSULTAR_DESCONTOS:
            return { ...state, error: true, loadingRequest: false, respostaConsultaDescontos: [], dadosProtocoloCadherd: {} }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_REQUERIMETO_SUCESSO:
            return { ...state, loadingRequerimentos: false, requerimentoSucesso: true, requerimentoErro: false }
        case ENTIDADES_ASSOCIATIVAS_CONSULTAR_REQUERIMETO_ERRO:
            return { ...state, loadingRequerimentos: false, requerimentoSucesso: false, requerimentoErro: true };
        //Requerimento
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_FEEDBACKS:
            return { ...state, feedbackRequerimentos: action.payload }
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_DADOS_CONTATO:
            return { ...state, dadosContato: action.payload }
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_LISTA_DESCONTOS_NAO_AUTORIZADOS:
            return { ...state, listaEntidadesNaoAutorizadas: action.payload };
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_SET_LISTA_DESCONTOS_AUTORIZADOS:
            return { ...state, listaEntidadesAutorizadas: action.payload }
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_INICIAR_REQUISICAO:
            return { ...state, error: false, loadingRequerimentos: true }
        case ENTIDADES_ASSOCIATIVAS_PEDIR_DEVOLUCAO_FINALIZAR_REQUISICAO:
            return { ...state, error: false, loadingRequerimentos: false }
        default:
            return state;
    }

}